import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowRightCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 12H8.75M13 14.25 15.25 12 13 9.75M4.75 12a7.25 7.25 0 1 0 14.5 0 7.25 7.25 0 0 0-14.5 0"
    />
  </svg>
);
export default SvgArrowRightCircle;
